<template lang="pug">
v-dialog(
  scrollable lazy
  v-model='dialog'
  max-width='600px'
)
  v-card
    v-toolbar(color='primary' dark)
      v-btn(icon dark @click='close'): v-icon close
      v-toolbar-title
        span 匯出 CSV
        v-tooltip(right)
          v-btn.my-0(small icon flat :ripple='false' slot='activator')
            v-icon(small) fas fa-question-circle
          span .csv 格式文件可使用 Microsoft Excel 或 Numbers 等試算表軟體開啟

    //- 表單
    v-card-text
      v-alert(type='info' icon='group' :value='shouldShowSpecificGroupAlert')
        | 只匯出#[b {{ convertGroupText(formGroupId) }}]組

      template(v-if='shouldShowFilteredAlert')
        v-alert(type='info' icon='search' :value='true' v-if='forms.length')
          | 只匯出搜尋/篩選後的 #[b {{ forms.length }}] 筆報名表單
          v-btn.mr-4.my-0(depressed small flat dark @click='$emit("resetSearchAndFilter")') 重設搜尋/篩選

        v-alert(type='warning' icon='search' :value='true' v-else)
          | 在目前套用的搜尋/篩選條件下找不到符合的報名表單
          v-btn.mr-4.my-0(depressed small flat dark @click='$emit("resetSearchAndFilter")') 重設搜尋/篩選

      v-subheader.pl-0 選擇 / 排序匯出欄位
      .group-drag
        v-layout(row wrap)
          v-flex(xs12 sm6)
            .primary--text.body-2.mb-2 已選擇 ({{ selectedColumns.length }})
            draggable.drag-area(v-model='selectedColumns' group='col' handle='.handle')
              transition-group(name='list')
                ExportCsvDragItem(v-for='(column, index) in selectedColumns' :key='column')
                  b {{ column }}
                  template(#action)
                    v-icon(@click='removeItem(index)' color='error' :disabled='isDisabled') close

          v-flex(xs12 sm6)
            .body-2.mb-2 未選擇 ({{ unselectedColumns.length }})
            draggable.drag-area(v-model='unselectedColumns' group='col' handle='.handle')
              transition-group(name='list')
                ExportCsvDragItem(v-for='(column, index) in unselectedColumns' :key='column')
                  span {{ column }}
                  template(#action)
                    v-icon(@click='addItem(index)' color='primary') add

      v-divider.my-1
      v-checkbox.ma-0(label='共同自定義欄位' v-model='isExportCommonField' color='primary' hide-details)
      v-checkbox.ma-0(label='組別自定義欄位' v-model='isExportCustomField' color='primary' hide-details)
    v-divider
    //- 工具列
    v-card-actions
      v-spacer
      v-btn(flat @click='close') {{ $t('cancel') }}
      v-btn.primary--text(flat @click='submit')  #[v-icon(left small) fas fa-download] 匯出
</template>

<script>
import { formStatus } from '@/mixins/formStatus'
import draggable from 'vuedraggable'
import Loader from '@/components/Loader.vue'
import ExportCsvDragItem from '@/components/form/ExportCsvDragItem.vue'
import exportFile from '@/assets/js/exportFile'

export default {
  name: 'ExportCsv',
  props: {
    forms: {
      type: Array,
      default: () => [],
    },
    headers: {
      type: Array,
    },
    formGroupId: {
      type: Number,
      default: -1,
    },
    isFiltered: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      selectedColumns: [...exportFile.columnNames],
      unselectedColumns: [],
      isExportCommonField: true,
      isExportCustomField: true,
    }
  },
  methods: {
    init () {
      this.clearError()
      this.dialog = true
    },
    submit () {
      const options = {
        schoolName: this.$store.getters.schoolName,
        formGroupId: this.formGroupId,
        columns: this.selectedColumns,
        isExportCommonField: this.isExportCommonField,
        isExportCustomField: this.isExportCustomField,
      }
      exportFile.csv(this.forms, this.headers, options)
    },
    addItem (index) {
      this.selectedColumns.push(this.unselectedColumns[index])
      this.unselectedColumns.splice(index, 1)
    },
    removeItem (index) {
      if (!this.isDisabled) {
        this.unselectedColumns.push(this.selectedColumns[index])
        this.selectedColumns.splice(index, 1)
      }
    },
  },
  computed: {
    isDisabled () {
      return this.selectedColumns.length <= 1
    },
    shouldShowSpecificGroupAlert () {
      return this.formGroupId !== -1
    },
    shouldShowFilteredAlert () {
      return this.isFiltered
    },
  },
  components: {
    Loader,
    draggable,
    ExportCsvDragItem,
  },
  mixins: [formStatus],
}
</script>

<style scoped lang="sass">
.group-drag
  overflow: visible

.drag-area
  height: 100%
</style>
